import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import userApi from "../../api/user/user.api";
import { useState } from "react";
import ProcessingBar from "../../Util/Processingbar";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";

const ForgotPasswordForm = ({ switchAuthState }) => {
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsUploading(true);
        const response = await userApi.forgotPassword(values.email);

        console.log({ response });

        // Only show toast if success is true
        if (response?.response?.data?.success === true) {
          toast.success(response?.response?.data?.message);
          resetForm();
          dispatch(setAuthModalOpen(false));
          navigate("/");
        } else if (response?.err?.success === false) {
          toast.error(response?.err?.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Reset failed");
      } finally {
        setIsUploading(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <input
        type="email"
        name="email"
        placeholder="Enter your email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched.email && formik.errors.email && (
        <p className="text-red-500 text-sm">{formik.errors.email}</p>
      )}

      <button
        type="submit"
        className="w-full text-black hover:text-white py-2 rounded-md"
        style={{ background: "linear-gradient(-45deg, #fed693, #ca7100)" }}
      >
        {isUploading ? <ProcessingBar /> : "Send Reset Link"}
      </button>

      {/* Divider */}
      <div className="flex items-center my-8">
        <div className="flex-grow h-px bg-gray-500"></div>
        <span className="px-4 text-sm text-neutral-300">OR</span>
        <div className="flex-grow h-px bg-gray-500"></div>
      </div>

      <button
        type="button"
        onClick={() => switchAuthState("signin")}
        className="w-full text-center text-yellow-500 hover:text-white mt-4 py-2 rounded-md border border-yellow-700"
      >
        Sign In
      </button>
    </form>
  );
};

export default ForgotPasswordForm;
